function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.78 23l-6.92-5.23a.7.7 0 01-.33-.77.65.65 0 01.69-.41h8.55l2.64-8.53s.12-.57.59-.57.58.56.58.56l2.64 8.54h8.56a.65.65 0 01.69.41.68.68 0 01-.33.75L25.22 23l2.65 8.53a.73.73 0 01-.16.82c-.38.29-.79-.1-.79-.1L20 27l-6.91 5.3s-.42.38-.8.09a.7.7 0 01-.15-.81L14.78 23z"
}));